export const useQuery = (location: string) => {
  const url = new URLSearchParams(location)
  return url
}
